import styled from 'styled-components';
import { HeImgix } from '../../../../../../common/components/images/HeImgix';
import { useMobile } from '../../../../../../common/services/screenSize/ScreenSizeService';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { onMobile } from '../../../../../../common/styles/onMobile';

interface Props {
  image: string;
}

export const Logo = ({ image }: Props) => {
  const mobile = useMobile();

  return (
    <View>
      <HeImgix
        height={mobile ? 64 : 88}
        width={mobile ? 80 : 138}
        src={image}
        imgixParams={{ fit: 'crop', fill: 'color', 'fill-color': 'fff' }}
        htmlAttributes={{
          alt: '',
          draggable: false,
          width: 'unset !important',
          height: 'unset !important',
        }}
      />
    </View>
  );
};

const View = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono200};
  border-radius: 4px;
  display: flex;
  flex-shrink: 0;
  height: 88px;
  justify-content: center;
  margin-inline-start: 8px;
  overflow: hidden;
  user-select: none;
  width: 138px;

  ${onMobile} {
    height: 64px;
    width: 80px;
  }
`;
